import React, { Component } from 'react';
import DropdownRow from './c_dropdown_row';
import Lang from '../../../i18n'
import { withRouter } from 'react-router-dom'

var classNames = require('classnames');

class DropdownGroup extends Component{
  constructor(props) {
    super(props);
    this.handleChangeInk = this.handleChangeInk.bind(this);
    this.handleChangePretreatment = this.handleChangePretreatment.bind(this);
    this.handleChangeDin = this.handleChangeDin.bind(this);
  }

  handleChangeInk(selected) {
    this.props.onChangeInk(selected);
  }

  handleChangePretreatment(selected) {
    this.props.onChangePretreatment(selected);
  }

  handleChangeDin(selected) {
    this.props.onChangeDin(selected);
  }

  render() {
    const styles = this.props.styles;
    const pretreatment_data = this.props.pretreatmentData;
    const selectedPretreatment = this.props.pretreatment;
    const din_data = this.props.dinData;
    const selectedDin = this.props.din;
    const ink_data = this.props.inkData;
    const selectedInk = this.props.ink;
    return(
      <div className={classNames(styles.inputItem, styles.modulCalc)}>
        <DropdownRow
          styles={styles}
          data={ink_data}
          onChange={this.handleChangeInk}
          description={Lang.translate('calculator:inkPack', this.props.location.pathname)}
          unitInfo="ml"
          name="inkQty"
          selected={selectedInk}
        />
        <DropdownRow
          styles={styles}
          data={pretreatment_data}
          onChange={this.handleChangePretreatment}
          description={Lang.translate('calculator:pretreatPack', this.props.location.pathname)}
          unitInfo="kg"
          name="pretreatment"
          selected={selectedPretreatment}
        />
        <DropdownRow
          styles={styles}
          data={din_data}
          onChange={this.handleChangeDin}
          description={Lang.translate('calculator:printArea', this.props.location.pathname)}
          unitInfo="DIN"
          name="din"
          selected={selectedDin}
          preselect='2'
          footnoteText={Lang.translate('calculator:printFormatText', this.props.location.pathname)}
        />
      </div>
    );
  }
}

export default withRouter(DropdownGroup);



// WEBPACK FOOTER //
// ./src/components/calculator/inputs/c_dropdown_group.js